import { createContext } from 'react';
import { DashboardResultsContextProps } from './DashboardResults.types';

export const DashboardResultsContext = createContext<DashboardResultsContextProps>(
  {} as DashboardResultsContextProps
);
